module.exports = __webpack_public_path__ + "img/eu.53eaf09b.png";